module.exports = __webpack_public_path__ + "img/shahr-financial-group-gray.b192ec4.png";